import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { StandardEvents } from '@shopify/events';
import { formatMoney } from '@theme/money-formatting';
import { discountedTotal, parseTiers } from '@theme/eme-quantity-breaks-core';

class EmeAddToCartTotal extends Component {
  #form = null;

  connectedCallback() {
    super.connectedCallback();
    this.#form = this.closest('product-form-component');
    this.#form?.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#render);
    this.#form?.addEventListener('input', this.#handleInput);
    document.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#render();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#form?.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.#render);
    this.#form?.removeEventListener('input', this.#handleInput);
    document.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#form = null;
  }

  #handleInput = (event) => {
    if (event.target instanceof HTMLInputElement && event.target.name === 'quantity') this.#render();
  };

  #handleProductSelect = async (event) => {
    try {
      await event.promise;
    } catch (error) {
      if (error?.name !== 'AbortError') throw error;
      return;
    }
    requestAnimationFrame(this.#render);
  };

  #render = () => {
    if (!this.isConnected) return;
    const input = this.#form?.querySelector('quantity-selector-component input[name="quantity"]');
    const quantity = input instanceof HTMLInputElement ? Number.parseInt(input.value, 10) : 1;
    const total = discountedTotal(Number(this.dataset.unitPrice), quantity > 0 ? quantity : 1, parseTiers(this.dataset.tiers));
    const text = formatMoney(total, this.dataset.moneyFormat || '{{amount}}', this.dataset.currency || 'EUR');
    if (this.textContent !== text) this.textContent = text;
  };
}

if (!customElements.get('eme-add-to-cart-total')) {
  customElements.define('eme-add-to-cart-total', EmeAddToCartTotal);
}
